import { TCompanyRootReducer } from './index.company';
import { INotificationsList } from '../components/NotificationComponent/INotification';

export const getNotificationsList =
  (state:TCompanyRootReducer):INotificationsList => state.companyReducer.notificationsList;

export const getUserSignedIn =
  (state:TCompanyRootReducer):boolean => state.companyReducer.userSignedIn;
